enum EActiveType {
  PROMOTION = 'promotion',
  STICKER = 'sticker',
}

export default EActiveType;
